import { controlTypes } from "../../config/fields";
import { invokePostService, setAiRequestEntity, updateAiAssistant } from "../../store/global/actions";
import { generateUniqueEventName } from "../../utils/llmUtils";
import { getDetailsFromUrl } from "../blueprint";



export const generateViewTransactionWithAI = async ({ newView, selectedView, viewChanges, sequence_id, view_type, setNoficationMessage, dispatch, isCreate, signal }) => {

    try {
        const { name: viewName, desc: viewDesc = "" } = newView || {};
        const processedView = JSON.parse(JSON.stringify(newView || {}));

        const widgetPromises = [];
        const parallel_triggering_events = [];
        const newTransactions = [];
        const newFields = [];
        const newMessages = [];
        const newEvents = [];
        const newMappedTransactions = [];
        const newHandlers = [];
        let notificationMessages = [];

        if (viewChanges?.create?.length > 0 || viewChanges?.update?.after?.length > 0) {

            for (const section of processedView.view_schema) {
                for (const widget of section.children) {
                    notificationMessages.push(`Generating transaction for ${widget.name || ""}`);
                    if (widget.type === 'control-button' || widget.type ===   'control-joystick') continue;
                    
                    widgetPromises.push(
                        processWidget({ section, widget, processedView, viewName, viewDesc, view_type, sequence_id, entityId: newView?._id, newView, parallel_triggering_events, setNoficationMessage, dispatch, isCreate, signal })
                    );
                }
            }

            setNoficationMessage(notificationMessages);


            try {
                const results = await Promise.all(widgetPromises);
               
                results.forEach(item => {
                    if (item.status) {
                        const data = item.data || {}
                        newTransactions.push(...(data.newTransactions || []));
                        newFields.push(...(data.newFields || []));
                        newMessages.push(...(data.newMessages || []));
                        newEvents.push(...(data.newEvents || []));
                        newMappedTransactions.push(...(data.newMappedTransactions || []));
                        newHandlers.push(...(data.newHandlers || []));
                    } 
                });
                const transactionGenerationFlag = results.every(item => item.status);
                
                if (transactionGenerationFlag) {
                    setNoficationMessage(["Transaction generated for every widgets"]);
                } else {
                    setNoficationMessage(["Transaction generated for some widgets"]);
                }
            } catch (error) {
                console.error("error-->", error)
            }
        }

        // To avoid duplicate transaction names
        const usedTransactionNames = new Set();
        const getUniqueTransactionName = (name) => {
            const baseName = name;
            let uniqueName = baseName;
            let counter = 2;
      
            while (usedTransactionNames.has(uniqueName)) {
              uniqueName = `${baseName}_${counter}`;
              counter++;
            }
      
            usedTransactionNames.add(uniqueName);
      
            return uniqueName;
        };

        newTransactions.forEach(transaction => {
            transaction.name = getUniqueTransactionName(transaction.name);
        });


        /**  SINGLE FINAL SAVE */
        console.log({
            newTransactions,
            newEvents,
        })
        const saveResult = await dispatch(invokePostService('llmSaveViewAndFetchTxns', {
            newTransactions,
            newFields,
            newMessages,
            newEvents,
            generatedMappedTransactions: newMappedTransactions,
            newHandlers,
            view: processedView,
            existingView: selectedView,
            viewChanges,
        }, {}, false, signal));
        if (saveResult?.aborted) return saveResult; 
        if (!saveResult.status) return { status: false };

        return { status: true, view: processedView };

    } catch (error) {
        console.error("AI Transaction generation failed:", error);
        return { status: false };
    } finally {
        dispatch(setAiRequestEntity(null));
    }
};



const processWidget = async ({ section, widget, processedView, viewName, viewDesc, view_type, sequence_id, entityId, newView, parallel_triggering_events = [], individualGeneration, setNoficationMessage, dispatch, isCreate, signal }) => {
    try {
        const data = {
            section_name: section.name,
            section_desc: section.desc || "",
            section_helperText: section.helperText || "",
            id: widget.id,
            view_name: viewName,
            view_desc: viewDesc,
            widgetDetails: widget
        };

        let widgetResponse;

        try {

            const widgetResponseRes = await safeDispatch({
                action: dispatch(invokePostService("generateTransactionForSection", { widgetDetails: data, sequence_id, isCreate }, {}, false, signal)),
                step: "Transaction generation",
                entity: widget,
                setNoficationMessage
            });
            if ( widgetResponseRes?.aborted || !widgetResponseRes.status) return widgetResponseRes;

            widgetResponse = widgetResponseRes.data;

        } catch (error) {
            console.error("Error:", error)
            return createError({
                step: "Transaction generation",
                message: `Transaction generation`,
                error,
                entity: widget
            });
        }

        let iterate = true;
        let iterateCount = 0;
        const ITERATE_THRESHOLD = 1;
        // const isCreate = isCreate;

        const result = {
            newTransactions: [],
            newFields: [],
            newMessages: [],
            newEvents: [],
            newMappedTransactions: [],
            newHandlers: []
        };


        while (iterate && ITERATE_THRESHOLD >= iterateCount) {
            ++iterateCount;

            if (doesAbort()) return createAbort();
            const queryPlanRes = await safeDispatch({
                action: dispatch(invokePostService('llmQueryPlan', {
                    view: newView,
                    generatedMappedTransactions: widgetResponse?.generatedMappedTransactions,
                    section_name: section.slug,
                    sequence_id,
                    isCreate,
                    sectionId: section.id,
                    widgetId: widget.id
                }, {}, false, signal)),
                step: "Transaction querying",
                entity: widget,
                setNoficationMessage
            });
            if ( queryPlanRes?.aborted || !queryPlanRes.status) return queryPlanRes;

            const queryPlan = queryPlanRes.data

            const genMapTxn = queryPlan?.generatedMappedTransactions
            if (genMapTxn && genMapTxn?.length) {
                genMapTxn.forEach(txn => {
                    let triggerEvent = txn?.children[0];
                    triggerEvent.slug_name = generateUniqueEventName(triggerEvent, parallel_triggering_events)
                })
            }

            if (doesAbort()) return createAbort();
            const messageFieldsRes = await safeDispatch({
                action: dispatch(invokePostService('llmViewMessageDef', {
                    view: processedView,
                    generatedMappedTransactions: queryPlan?.generatedMappedTransactions,
                    view_type,
                    sectionId: section.id,
                    widgetId: widget.id,
                    sequence_id,
                    isCreate
                }, {}, false, signal)),
                step: "Transaction message generation",
                entity: widget,
                setNoficationMessage
            });
            if (messageFieldsRes?.aborted || !messageFieldsRes.status) return messageFieldsRes;

            const messageFields = messageFieldsRes.data;

            let handlerDefinitions, handlersCode, handlerValidationStatus, handlerValidation;
            let validateIterate = 0

            while (validateIterate < 2 && !handlerValidationStatus) {
                validateIterate++;
                if (doesAbort()) return createAbort();
                const handlerDefinitionsRes = await safeDispatch({
                    action: dispatch(invokePostService('llmFetchHandlerDef', {
                        newTransactions: messageFields?.newTransactions,
                        newFields: messageFields?.newFields,
                        newMessages: messageFields?.newMessages,
                        newEvents: messageFields?.newEvents,
                        view: newView,
                        sectionId: section.id,
                        widgetId: widget.id,
                        sequence_id,
                        isCreate,
                        failedHandlers: handlerValidation ?? undefined,
                        tables: queryPlan?.tables
                    }, {}, false, signal)),
                    step: "Handler definition generation",
                    entity: widget,
                    setNoficationMessage
                });
                if (handlerDefinitionsRes?.aborted || !handlerDefinitionsRes.status) return handlerDefinitionsRes;

                handlerDefinitions = handlerDefinitionsRes.data;

                if (doesAbort()) return createAbort();

                const handlersCodeRes = await safeDispatch({
                    action: dispatch(invokePostService('llmFetchHandlerCode', {
                        newTransactions: handlerDefinitions?.newTransactions,
                        newFields: handlerDefinitions?.newFields,
                        newMessages: handlerDefinitions?.newMessages,
                        newEvents: handlerDefinitions?.newEvents,
                        handlersDef: handlerDefinitions?.handlersDef,
                        structuredTransaction: handlerDefinitions?.structuredTransaction,
                        correspondingWidget: handlerDefinitions?.correspondingWidget,
                        sequence_id,
                        isCreate,
                        failedHandlers: handlerValidation ?? undefined,
                        tables: queryPlan?.tables
                    }, {}, false, signal)),
                    step: "Handler code generation",
                    entity: widget,
                    setNoficationMessage
                });

                if (handlersCodeRes?.aborted || !handlersCodeRes.status) return handlersCodeRes;

                handlersCode = handlersCodeRes.data;

                if (doesAbort()) return createAbort();

                const handlerLLMCheckRes = await safeDispatch({
                    action: dispatch(invokePostService('llmHandlerValidation', {
                        handlersDef: handlersCode?.handlersCode?.events,
                        sequence_id,
                        tables: handlerDefinitions.tables,
                        isCreate
                    }, {}, false, signal)),
                    step: "Handler code generation",
                    entity: widget,
                    setNoficationMessage
                });
                if (handlerLLMCheckRes?.aborted || !handlerLLMCheckRes.status) return handlerLLMCheckRes;
                
                const handlerLLMCheck = handlerLLMCheckRes.data;

                if (doesAbort()) return createAbort();

                const handlerValidationRes = await safeDispatch({
                    action: dispatch(invokePostService('llmLuaValidate', {
                        handlerData: handlerLLMCheck?.handlerData
                    }, {}, false, signal)),
                    step: "Handler code generation",
                    entity: widget,
                    setNoficationMessage
                });
                if (handlerValidationRes?.aborted || !handlerValidationRes.status) return handlerValidationRes;
                
                handlerValidation = handlerValidationRes.data;

                if (!handlerValidation?.isHandlersValid || !handlerLLMCheck?.isHandlersValid) {
                    handlerValidationStatus = false;
                    if (validateIterate >= 2) {
                        return createError({
                            step: "Handler Validation",
                            entity: widget,
                            message: "Handler validation failed after retries",
                            meta: { handlerValidation }
                        });
                    }

                    continue;
                }
                handlerValidationStatus = true;

            }

            iterate = false;

            const mappedTransaction = handlersCode?.newTransactions?.[0];

            if (mappedTransaction) {
                if (controlTypes.includes(widget.type)) {
                    if (widget.type !== 'control-button' && widget.type !==  'control-joystick' ) {
                        widget.gettertransaction = mappedTransaction?._id?.toString();
                        widget.getterinstance = view_type === "summary" ? "Admin" : "{instance}";
                    }
                } else {
                    widget.mapping = {
                        source: "transaction",
                        transaction: mappedTransaction?._id?.toString(),
                        instance: view_type === "summary" ? "Admin" : "{instance}",
                        field: widget.name
                    };
                }  
            } 

            result.newTransactions.push(...(handlersCode?.newTransactions || []));
            result.newFields.push(...(handlersCode?.newFields || []));
            result.newMessages.push(...(handlersCode?.newMessages || []));
            result.newEvents.push(...(handlersCode?.newEvents || []));
            result.newMappedTransactions.push(...(messageFields?.generatedMappedTransactions || []));
            result.newHandlers.push(...(handlersCode?.handlersCode?.events || []));

        }

        return { status: true, data: result, entity: widget };
    } catch (error) {
        console.error("processWidget fatal error:", error)

        return createError({
            step: "processWidget",
            message: "Unexpected error occurred",
            error
        });
    }
};



const safeDispatch = async ({ action, step, entity, setNoficationMessage }) => {
    try {
        const response = await action;

        if (!response?.status) {
            setNoficationMessage([`Transaction generation failed for ${entity.name || ""}`]);
            throw new Error(response?.message || `${step} failed`);
        }

        return response;
    } catch (error) {
        setNoficationMessage([`Transaction generation failed for ${entity.name || ""}`]);
        return createError({
            step,
            message: `${step} failed`,
            error,
            entity
        });
    }
};

const createError = ({ step, message, error, entity }) => ({
    status: false,
    step,
    entity,
    message,
    error: error?.message || error
});


const doesAbort = () => {
    const { blueprintId } = getDetailsFromUrl();

    return !blueprintId
}


const createAbort = () => ({
    status: false,
    aborted: true,
    message: "Process aborted due to blueprint change"
});